// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import submitSiteMode from './submitSiteMode'
import submitPathMode from './submitPathMode'
import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'

import {
  removeAllPathValidationsFromDrawer,
  setPathsErrorValidations,
} from 'redux/modules/pathValidationsDrawer'

// everything is wrapped in a single loading toggler
// then it determines which mode of bulk edits we're in
// for finer handling of the submission.

// NOTE - we pass formProps down because we want to trigger opening the context modal
// from within the site submit handler for scenarios when we want to show the callsign cascade modal.

// we pass d through as well (dispatch from redux-form) just to be consistent with redux-form submit handler args.

const handleBulkUpdateSubmit = (formValues, d, formProps) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { bulkMode } = getState().form[BULK_EDITS_FILTER].values

        await (
          bulkMode === 'site'
            ? dispatch(submitSiteMode(formValues, d, formProps))
            : dispatch(submitPathMode(formValues, d, formProps))
        )
      } catch (err) {
        console.warn(err)

        // so since we're on bulk edits, there are a bunch of different ways in which the user can
        // generate errors for multiple paths. As there is no clear requirement here,
        // the simplest solution for handling these errors is by clearing any previous errors
        dispatch(removeAllPathValidationsFromDrawer())

        // and then setting the new error messages in the drawer
        dispatch(setPathsErrorValidations(err))
      }
    }
  ))
)

export default handleBulkUpdateSubmit
